module.exports = __webpack_public_path__ + "static/img/responsibility_manager.d923695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/responsibility/responsibility_manager.jpg
// module id = 7YBF
// module chunks = 1